module.exports = __webpack_public_path__ + "img/tips.7c4489fd.png";